import React from 'react';
import GlobalStore from '../../stores/global-store';
import useComponentVisible from '../../hooks/useComponentVisible';
import ELSALogo from '../../assets/images/elsa-logo-black.svg';
import { storageGetItem } from '../../utils/local-storage';
import { USER_PROFILE } from '../../utils/storage-keys';
import './Header.css';
import { Link } from 'react-router-dom';

function Header({ onToggleNavbar }) {
  const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible(false);
  const { signOut } = GlobalStore.useContainer();
  const userProfile = JSON.parse(storageGetItem(USER_PROFILE));

  return (
    <div className="navbar navbar-fixed navbar-light bg-light">
      <a className="navbar-brand" href="/">
        <img src={ELSALogo} alt="ELSA Speak" />
      </a>
      <div className="navbar-right">
        <div className="dropdown" ref={ref}>
          <button className="dropdown-toggle" type="button" onClick={() => setIsComponentVisible(prev => !prev)}>
            <img className="avatar" src={userProfile.avatar_url} alt={userProfile.display_name} width={24} />
          </button>
          <div className="dropdown-menu" style={{display: isComponentVisible ? 'block': 'none'}}>
            <div className="welcome">Chào <strong>{userProfile.display_name}</strong></div>
            <hr className="mt-2 mb-2" />
            <Link to="/profile" onClick={() => setIsComponentVisible(false)} className="dropdown-item">Profile</Link>
            <button style={{marginLeft: 'auto'}} className="btn btn-link dropdown-item" onClick={signOut}>Thoát</button>
          </div>
        </div>
        <button className="navbar-toggler" type="button" onClick={onToggleNavbar}>
          <span className="navbar-toggler-icon"></span>
        </button>
      </div>
    </div>
  )
}

export default Header;